import { render, staticRenderFns } from "./managerHotel.vue?vue&type=template&id=b21289ce&scoped=true&"
import script from "./managerHotel.vue?vue&type=script&lang=js&"
export * from "./managerHotel.vue?vue&type=script&lang=js&"
import style0 from "./managerHotel.vue?vue&type=style&index=0&id=b21289ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21289ce",
  null
  
)

export default component.exports